export default "__VITE_ASSET__5cKFC779__"